import { render, staticRenderFns } from "./ModalEditReason.vue?vue&type=template&id=5bd3b0e2&"
import script from "./ModalEditReason.vue?vue&type=script&lang=js&"
export * from "./ModalEditReason.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditReason.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports